export default __webpack_public_path__ + "34013a661520acd4eaa4b8eb43f586e1.svg";